import { render } from "./actionCustomCodeComponent.vue?vue&type=template&id=5a5b3b70&scoped=true"
import script from "./actionCustomCodeComponent.vue?vue&type=script&lang=js"
export * from "./actionCustomCodeComponent.vue?vue&type=script&lang=js"

import "./actionCustomCodeComponent.vue?vue&type=style&index=0&id=5a5b3b70&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5b3b70"]])

export default __exports__